import { render, staticRenderFns } from "./protocolo.vue?vue&type=template&id=5d0e13b4"
import script from "./protocolo.vue?vue&type=script&lang=js"
export * from "./protocolo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports